import { UserOutlined } from "@ant-design/icons";
import { CircleCiIcon } from "./CircleCiIcon";
import { GcalIcon } from "./GcalIcon";
import { GithubIcon } from "./GithubIcon";
import { JiraIcon } from "./JiraIcon";
import { SlackIcon } from "./SlackIcon";
import { GitlabIcon } from "./GitlabIcon";

const sizes = {
  xsmall: 12,
  small: 16,
  medium: 24,
  large: 32,
  xlarge: 48,
};

export function IntegrationIcon({
  source,
  size,
  style,
  className,
}: {
  source: string;
  size?: keyof typeof sizes | number;
  style?: React.CSSProperties;
  className?: string;
}) {
  const pixels = typeof size === "string" ? sizes[size] : size;
  return (
    <div style={{ display: "inline-block", ...style }} className={className}>
      {source === "github" ? (
        <GithubIcon size={pixels} />
      ) : source === "gitlab" ? (
        <GitlabIcon size={pixels} />
      ) : source === "jira" ? (
        <JiraIcon size={pixels} />
      ) : source === "circleci" ? (
        <CircleCiIcon size={pixels} />
      ) : source === "gcalendar" ? (
        <GcalIcon size={pixels} />
      ) : source === "slack" ? (
        <SlackIcon size={pixels} />
      ) : (
        //merged
        <UserOutlined size={pixels} style={{ width: pixels }} />
      )}
    </div>
  );
}
